import { RoutePaths } from "../../routes";

const authLinks = [
  {
    href: RoutePaths.root,
    label: "Environments",
  },
  {
    href: RoutePaths.translationUpdater,
    label: "Update translations",
  },
  {
    href: RoutePaths.environmentsCompare,
    label: "Environments compare",
  },
  {
    href: RoutePaths.releasePacks,
    label: "Release packs",
  },
  {
    href: RoutePaths.changelog,
    label: "Changelog",
  },
];

const links = [
  {
    href: RoutePaths.root,
    label: "Environments",
  },
  {
    href: RoutePaths.login,
    label: "Login",
  },
];

export { authLinks, links };
